import Interweave from "interweave";
import React from "react";
import nextId from "react-id-generator";
import { Link, useParams } from "react-router-dom";
import { getAllJobs, getJobDetails } from "../../../../APIs/GetAPIs";
import {
  addToAppliedJobs,
  saveJobCandidate,
  unSaveJobCandidate,
} from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import SimilarJobCard from "../../../Common/SimilarJobCard/SimilarJobCard";
import ApplyForJob from "../../../Portals/ApplyForJob/ApplyForJob";
import LoginPortal from "../../../Portals/LoginPortal/LoginPortal";
import { MainContext } from "../../DashboardContext/Context";
import "./job-description.style.scss";
import ShareModal from "./ShareModal/ShareModal";
export default function JobDescription() {
  let date = new Date();
  let cDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

  const { jobId } = useParams();
  const [openLogin, setOpenLogin] = React.useState(false);
  const [applying, setApplying] = React.useState(false);
  const [applyModalOpen, setApplyModalOpen] = React.useState(false);
  const context = React.useContext(MainContext);
  const { savedJobs, appliedJobs, setUpSavedJobArray, userDetails } = context;
  const [loading, setLoading] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  const [jobInfo, setJobInfo] = React.useState();
  const [saving, setSaving] = React.useState(false);
  const [shareModal, setShareModal] = React.useState(false);
  const [similarJobList, setSimilarJobList] = React.useState(null);

  const difference = (data) => {
    if (!data) {
      return "";
    }
    let oldDate = `${data[1]}/${data[0]}/${data[2]}`;
    let dateOne = new Date(`${oldDate}`);
    let dateTwo = new Date(`${cDate}`);
    let diff = dateTwo.getTime() - dateOne.getTime();
    diff = diff / (1000 * 3600 * 24);
    return diff;
  };

  const setUpJobInfo = async () => {
    setLoading(true);
    if (!jobId) return;
    try {
      let res = await getJobDetails(jobId);
      if (res.data.statusCode === 200) {
        let match = savedJobs.indexOf(res.data.data.jobId);
        let match2 = appliedJobs.indexOf(res.data.data.jobId);
        if (match == "-1" && match2 == "-1") {
          setJobInfo(res.data.data);
        } else {
          setJobInfo({
            ...res.data.data,
            saved: match == "-1" ? false : true,
            applied: match2 == "-1" ? false : true,
          });
        }
      }
    } catch (error) {}
  };
  React.useEffect(() => {
    if (!jobInfo) return;
    let match = savedJobs.indexOf(jobInfo.jobId);
    let match2 = appliedJobs.indexOf(jobInfo.jobId);
    if (match == "-1" && match2 == "-1") {
      setJobInfo(jobInfo);
    } else {
      setJobInfo({
        ...jobInfo,
        saved: match == "-1" ? false : true,
        applied: match2 == "-1" ? false : true,
      });
    }
  }, [savedJobs, appliedJobs]);
  const saveJob = async () => {
    try {
      setSaving(true);
      let res = await saveJobCandidate({ jobId: jobInfo.jobId });
      if (res.data.statusCode === 200) {
        setJobInfo({ ...jobInfo, saved: true });
        setUpSavedJobArray();
        setSaving(false);
      } else {
        alert("Not Saved");
        setSaving(false);
      }
    } catch (error) {}
  };
  const unSaveJob = async () => {
    try {
      setSaving(true);
      let res = await unSaveJobCandidate({ jobId: jobInfo.jobId });
      if (res.data.statusCode === 200) {
        setJobInfo({ ...jobInfo, saved: false });
        setUpSavedJobArray();
        setSaving(false);
      } else {
        alert("Not Saved");
        setSaving(false);
      }
    } catch (error) {}
  };
  const setUpSimilarJobList = async () => {
    let temp = {
      jobTitle: jobInfo.jobTitle.split(" ")[0] || "",
      city: jobInfo.city || "",
      country: "",
      jobCategory: jobInfo.jobCategory || "",
      custField4: "",
      jobDescription: "",
      start: "1",
      numOfRecords: "9",
      websitePublish: "",
      custField1: [""],
      jobType: [""],
      minSalary: "0",
      maxSalary: "100000000",
    };
    try {
      let res = await getAllJobs(temp);
      if (res.data.statusCode === 200) {
        let temp = res.data.data.map((x) => {
          let match = savedJobs.findIndex((y) => {
            return y === x.jobId;
          });
          if (match == -1) {
            return { ...x };
          } else {
            return { ...x, saved: true };
          }
        });
        temp = temp.filter((x) => {
          return x.jobId != jobId;
        });

        setSimilarJobList([...temp]);
      } else {
        setSimilarJobList([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    if (!jobInfo) return;
    setUpSimilarJobList();
  }, [jobInfo]);
  React.useEffect(() => {
    window.scrollTo({ top: 0 });
    setUpJobInfo();
  }, [jobId]);
  return !jobInfo ? (
    "Loading..."
  ) : (
    <div className="job-description-main">
      {shareModal ? (
        <ShareModal jobId={jobId} closeIt={() => setShareModal(false)} />
      ) : (
        ""
      )}
      {applyModalOpen && (
        <ApplyForJob
          closeIt={() => setApplyModalOpen(false)}
          jobInfo={jobInfo}
        />
      )}
      {openLogin && <LoginPortal closeIt={() => setOpenLogin(false)} />}
      <div className="jdm-routes">
        <p>
          <Link to="/user/list">All Jobs</Link> {">"}{" "}
          {jobInfo?.jobTitle || "Title"}
        </p>
      </div>
      <div className="job-title-card">
        <div className="jtc-left">
          <figure className="logo-wrapper">
            <img src={Images.menTree} />
          </figure>
          <figcaption>
            <div>
              <h6>{jobInfo?.jobTitle || "Title"}</h6>
              <span>{jobInfo?.clientName}</span>
            </div>
            <div>
              {!difference(jobInfo.dateOpened.split("-").reverse()) ? (
                ""
              ) : (
                <p>
                  <img src={Images.watchFilled} />
                  <span>
                    Post{" "}
                    <b>
                      {difference(jobInfo.dateOpened.split("-").reverse())} Days
                    </b>{" "}
                    ago
                  </span>
                </p>
              )}
              <p>
                <img src={Images.groupLogo} />
                <span>
                  {" "}
                  <b>{jobInfo?.appliedCount || "0"}</b> Applicants applied
                </span>
              </p>
              <p>
                <img src={Images.eyeLogo} />
                <span>
                  {" "}
                  <b>{jobInfo?.jobViewCount || "0"}</b> Views
                </span>
              </p>
            </div>
          </figcaption>
        </div>
        <div className="jtc-right">
          <button
            className={jobInfo.saved ? "saved" : ""}
            onClick={() => {
              if (!userDetails) {
                setOpenLogin(true);
                return;
              }
              jobInfo.saved ? unSaveJob() : saveJob();
            }}
          >
            {jobInfo.saved ? "Saved" : "Save"}
          </button>
          <button
            className={jobInfo.applied ? "applied" : ""}
            disabled={jobInfo.applied}
            onClick={() => {
              if (!userDetails) {
                setOpenLogin(true);
                return;
              }
              setApplyModalOpen(true);
            }}
          >
            {applying ? "Applying..." : jobInfo.applied ? "Applied" : "Apply"}
          </button>
          <button onClick={() => setShareModal(!shareModal)}>
            <img src={Images.shareLogo} />
          </button>
        </div>
      </div>
      <div className="jdm-body">
        <section className="jdm-left">
          <div className="jdml-info">
            <div>
              <h6>
                {jobInfo?.minWorkExp} - {jobInfo?.maxWorkExp} yrs
              </h6>
              <p>Experience</p>
            </div>

            <div>
              <h6>1 - 5</h6>
              <p>Class</p>
            </div>
            {jobInfo?.custField1 ? (
              <div>
                <h6>{jobInfo?.custField1}</h6>
                <p>curriculum</p>
              </div>
            ) : (
              ""
            )}
            <div>
              <h6>
                {jobInfo.minSalary || "0"} - {jobInfo.maxSalary}
              </h6>
              <p>Salary Offered</p>
            </div>

            <div>
              <h6>B.Ed</h6>
              <p>Qualification Required</p>
            </div>
          </div>
          <div className="lcm-options">
            <div
              className={
                selectedOption.id === "jd" ? "left-most" : "right-most"
              }
            />
            {options.map((obj) => (
              <h6
                onClick={() => setSelectedOption(obj)}
                className={obj.id === selectedOption.id ? "selected" : ""}
                key={obj.keyId}
              >
                {obj.text}
              </h6>
            ))}
          </div>
          <div className="job-describe">
            <Interweave
              content={
                selectedOption.id === "about" ? "NA" : jobInfo?.jobProfile
              }
            />
          </div>
        </section>
        <aside className="jdm-right">
          <div className="jdmr-header">
            <h5>Similar Jobs</h5>
          </div>
          <div className="jdmr-body">
            {similarJobList?.slice(0, 3).map((obj) => (
              <div className="jdmr-card-wrapper">
                <SimilarJobCard data={obj} />
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
}

const options = [
  { keyId: nextId(), id: "jd", text: "Job Description" },
  { keyId: nextId(), id: "about", text: "About Us" },
];
